import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/admin/customers").then(({ data }) => setUsers(data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-display font-extrabold text-4xl tracking-tighter text-white">Customers</h1>
      <p className="mt-1 text-sm text-white/50">{users.length} accounts</p>

      <div className="mt-8 card-elev rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0812] text-[10px] tracking-[0.22em] uppercase text-white/40 font-bold">
            <tr>
              <th className="text-left px-5 py-3">Name</th>
              <th className="text-left px-5 py-3">Email</th>
              <th className="text-right px-5 py-3">Orders</th>
              <th className="text-right px-5 py-3">Total spend</th>
              <th className="text-right px-5 py-3">Kavo Pts</th>
              <th className="text-left px-5 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`customer-row-${u.email}`}>
                <td className="px-5 py-3 text-white">{u.name}</td>
                <td className="px-5 py-3 text-white/70">{u.email}</td>
                <td className="px-5 py-3 text-right font-mono text-white">{u.order_count}</td>
                <td className="px-5 py-3 text-right font-mono text-white">{formatPrice(u.total_spend_cents)}</td>
                <td className="px-5 py-3 text-right font-mono text-[#B026FF]">{u.loyalty_points}</td>
                <td className="px-5 py-3 text-white/50 text-xs">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {users.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-white/50">No customers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
